import HeaderNavItemSB from '@/components/atoms/layout/header/HeaderNavItemSB';
import { HeaderProps } from '@/components/atoms/layout/header/HeaderSB';
import LinkButton from '@/components/atoms/linkButton';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

type HeaderNavItemListSBProps = Required<
  Required<HeaderProps['header']>['firstLevels'][number]
>['secondLevels'][number];

export default function HeaderNavItemListSB({
  block,
}: BlockComponentModel<HeaderNavItemListSBProps>) {
  const { thirdLevels, link, title } = block;

  return (
    <div className='flex flex-col'>
      {link ? (
        <LinkButton
          href={link.url}
          variant='text'
          color='tertiary'
          showRightChevron
          underline={false}
          slim
          classNames={{ root: 'text-label-text-l mb-3 pl-3 text-neutral-N40' }}
        >
          {link?.text || title}
        </LinkButton>
      ) : (
        <div className='text-label-text-l text-neutral-N40 mb-3 pl-3'>
          {title}
        </div>
      )}
      {thirdLevels?.map((item, index) => (
        <div key={index}>
          <HeaderNavItemSB block={item} />
        </div>
      ))}
    </div>
  );
}
